export { MailPage as default } from '@/components/enpages/Ir/Mail'
